"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRtl = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const react_native_1 = require("react-native");
const rtl_detect_1 = tslib_1.__importDefault(require("rtl-detect"));
const useConfig_1 = require("./useConfig");
function useRtl() {
    const [direction, setDirection] = useConfig_1.useConfig('direction');
    const [locale] = useConfig_1.useConfig('locale');
    const [rtl, setRtl] = react_1.useState(false);
    /**
     * Calculate and update RTL flag based on locale and direction
     *
     * @param slug
     * @param BB
     */
    function updateRtl() {
        // Decide if layout should be RTL or not
        let shouldBeRtl = false;
        // Left to Right
        if (direction === 'ltr') {
            shouldBeRtl = false;
        }
        // Right to Left
        else if (direction === 'rtl') {
            shouldBeRtl = true;
        }
        // direction === 'auto'
        else {
            shouldBeRtl = !!rtl_detect_1.default.isRtlLang(locale);
        }
        // Everything is it should be, so do nothing
        if (shouldBeRtl === rtl) {
            return;
        }
        // Update layout
        react_native_1.I18nManager.forceRTL(shouldBeRtl);
        // Update state
        setRtl(shouldBeRtl);
    }
    react_1.useEffect(updateRtl, [direction, locale]);
    return {
        direction,
        rtl,
        setDirection,
    };
}
exports.useRtl = useRtl;
